export const calculateAxisValue = (state, type) => {
  let axis = null;
  if (
    (state.properties &&
      state.properties.visual &&
      state.properties.visual.options &&
      state.properties.visual.options[type]) ||
    state.properties.visual.options[type] === 0
  ) {
    axis = state.properties.visual.options[type];
  }
  return axis;
};
